module.exports = __webpack_public_path__ + "static/media/top.44579ce2.png";